var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3",class:_vm.sizeClassObject},[_c('temp-ranking-confirmation-list',{ref:"confirmationsListGrid",attrs:{"confirmationExpanded":_vm.expanded},on:{"sizeToggle":_vm.sizeToggle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }